import { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import cc from 'classcat';
import dayjs from 'dayjs';
import i18n from 'i18next';
import {
  durationHours,
  TimesToAdd
} from 'utils/constants/dateInfo/time-numbers';
import { TAdvancedSelectedRangeFilter } from 'interfaces/sportsbook';
import {
  setAdvancedSelectedRangeFilter,
  setAdvancedTempCompetitionIds
} from 'store/actions/new-sportsbook';
import './index.less';

const RANGE_FILTER_VALUES: TAdvancedSelectedRangeFilter[] = [
  {
    title: i18n.t('sportsbook.all')
  },
  {
    title: i18n.t('sportsbook.next3hour'),
    ranges: {
      '@gt': dayjs().unix(),
      '@lt': dayjs().add(durationHours.THREE_HOURS, 'hour').unix()
    }
  },
  {
    title: i18n.t('sportsbook.next6hour'),
    ranges: {
      '@gt': dayjs().unix(),
      '@lt': dayjs().add(durationHours.SIX_HOURS, 'hour').unix()
    }
  },
  {
    title: i18n.t('sportsbook.next24hour'),
    ranges: {
      '@gt': dayjs().unix(),
      '@lt': dayjs().add(TimesToAdd.AFTER_1_DAYS, 'day').unix()
    }
  },
  {
    title: i18n.t('sportsbook.next3days'),
    ranges: {
      '@gt': dayjs().unix(),
      '@lt': dayjs().add(TimesToAdd.AFTER_3_DAYS, 'day').endOf('day').unix()
    }
  },
  {
    title: i18n.t('sportsbook.today'),
    ranges: {
      '@gt': dayjs().unix(),
      '@lt': dayjs().endOf('day').unix()
    }
  },
  {
    title: i18n.t('sportsbook.tomorrow'),
    ranges: {
      '@gt': dayjs().endOf('day').unix(),
      '@lt': dayjs().endOf('day').add(TimesToAdd.AFTER_1_DAYS, 'day').unix()
    }
  },
  {
    title: dayjs().add(TimesToAdd.AFTER_2_DAYS, 'day').format('ddd'),
    ranges: {
      '@gt': dayjs().add(TimesToAdd.AFTER_2_DAYS, 'day').startOf('day').unix(),
      '@lt': dayjs().add(TimesToAdd.AFTER_2_DAYS, 'day').endOf('day').unix()
    }
  }
];

type TAdvancedRangeFilterProps = {
  selectedRange: TAdvancedSelectedRangeFilter | null;
};

export const AdvancedRangeFilter = ({
  selectedRange
}: TAdvancedRangeFilterProps) => {
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    if (!selectedRange) {
      dispatch(setAdvancedSelectedRangeFilter(RANGE_FILTER_VALUES[0]));
    }
  }, []);

  const handleSelectRange = (selectedRange: TAdvancedSelectedRangeFilter) => {
    dispatch(setAdvancedSelectedRangeFilter(selectedRange));
    dispatch(setAdvancedTempCompetitionIds([]));
  };

  return (
    <div className="advancedRangeFilter">
      {RANGE_FILTER_VALUES.map(range => (
        <div
          className={cc([
            'advancedRangeFilter__item',
            {
              'advancedRangeFilter__item--active':
                selectedRange?.title === range.title
            }
          ])}
          key={range.title}
          onClick={() => handleSelectRange(range)}
        >
          {range.title}
        </div>
      ))}
    </div>
  );
};
